export default "__VITE_ASSET__CSyWXN0v__"